/**
 * 模块: TrendAnalysis常量配置
 * 职责: 定义可用指标等常量
 * 限制: 文件<280行
 */

export const AVAILABLE_METRICS = [
  { key: 'market_control', label: '市场控制度' },
  { key: 'replacement_rate', label: '真实替换率' },
  { key: 'position_retention', label: '位置保持率' },
  { key: 'conversion_advantage', label: '转化优势系数' },
  { key: 'brand_penetration', label: '品牌渗透指数' },
  { key: 'brand_concentration', label: '品牌集中度' },
  { key: 'brand_diversity', label: '品牌多样性' },
  { key: 'brand_stability', label: '品牌稳定性' },
  { key: 'market_opportunity', label: '市场机会指数' },
  { key: 'market_stability', label: '市场稳定指数' },
  { key: 'rank_cagr', label: '搜索排名CAGR(%)' },
  { key: 'top3_click_share_cagr', label: 'Top3点击份额CAGR(%)' },
  { key: 'top3_conversion_share_cagr', label: 'Top3转化份额CAGR(%)' },
];

export const DEFAULT_METRICS = [
  'market_control',
  'replacement_rate',
  'market_opportunity',
];

